var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "editableContainer",
      staticClass: "editable-wrapper",
      class: { "editable-area": _vm.editable },
      on: { click: _vm.handleClick }
    },
    [
      _c("Transition", { attrs: { name: "editor-pop", appear: "" } }, [
        _vm.isEditing
          ? _c(
              "div",
              { ref: "editorContainer", staticClass: "editor-container" },
              [
                _c("div", { staticClass: "editing-label" }, [
                  _vm._v(_vm._s(_vm.editLabel))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "inline-editor-wrapper" },
                  [
                    _c("TipTapEditor", {
                      ref: "tiptapEditor",
                      staticClass: "inline-editor__input",
                      attrs: {
                        editorStyles: {
                          "max-height": "60vh",
                          overflowY: "scroll"
                        },
                        showVideoEmbed: "",
                        extended: "",
                        showGenerateWithAI: ""
                      },
                      on: {
                        onEscape: _vm.cancelEdit,
                        onEnter: _vm.handleEnter,
                        "editor-created": _vm.handleEditorCreated,
                        click: function($event) {
                          $event.stopPropagation()
                        },
                        getAISuggestion: _vm.handleGetAISuggestion,
                        acceptAISuggestion: _vm.handleAcceptAISuggestion
                      },
                      model: {
                        value: _vm.editedValue,
                        callback: function($$v) {
                          _vm.editedValue = $$v
                        },
                        expression: "editedValue"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.isEditing
        ? _c("div", {
            ref: "modalBackdrop",
            staticClass: "popup-backdrop",
            on: { click: _vm.saveEdit }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }